(function($, undefined) {
	'use strict';

	$(window).ready(function () {
		var util = Fw.component.models().utils;
		var state = {};
		
		$('.tab').click(function () {
			var t = $(this);
			var tab = t.attr('data-tab');
			var family = t.attr('data-tab-family');
			var param = t.attr('data-param');
			
			$('.tab[data-tab-family="'+family+'"]').removeClass('selected');
			t.addClass('selected');
			
			$('.tab-ctn[data-tab-family="'+family+'"]').removeClass('selected');
			$('.tab-ctn[data-tab-family="'+family+'"][data-tab="'+tab+'"]').addClass('selected');
			
			state = { t: tab, tf: family };
			util.changeURLState(param, tab, Object.assign({}, state));
		});
		
		if ($('.tab')[0]) {
			window.addEventListener("popstate", function(e) {
				var tab = e.state ? e.state.t : state.t;
				var family = e.state ? e.state.tf : state.tf;
				$('.tab[data-tab-family="'+family+'"]').removeClass('selected');
				$('.tab[data-tab-family="'+family+'"][data-tab="'+tab+'"]').addClass('selected');
				$('.tab-ctn[data-tab-family="'+family+'"]').removeClass('selected');
				$('.tab-ctn[data-tab-family="'+family+'"][data-tab="'+tab+'"]').addClass('selected');
			});
		}
	});

})(jQuery);

